import { API_URL } from 'env';
import { request, type TransitionResponse, type TransitionTagBrief } from './AppointmentTransition';

/** Nội dung `config` của một tính năng: thẻ S nguồn, thẻ S đích, có đồng bộ sang khách hàng không */
export interface FeatureSettingConfig {
    origin_customer_tag_ids?: number[];
    customer_tag_id?: number | null;
    /** Server tự đồng bộ bằng customer_tag_id */
    target_customer_tag_id?: number | null;
    sync_customer?: boolean;
    /** appointment_default_staff: nhân viên Trực page / Telesale gán sẵn khi tạo lịch hẹn */
    staff_id?: number | null;
    telesale_id?: number | null;
}

/** Nhân sự server trả kèm cấu hình appointment_default_staff */
export interface FeatureSettingStaff {
    id: number;
    name: string;
    phone?: string | null;
    avatar?: string | null;
    department_id?: number | null;
}

/** Cấu hình tự động của một tính năng (bảng system_feature_settings) */
export interface FeatureSetting {
    id: number;
    type: string;
    name: string;
    /** null = cấu hình chung toàn hệ thống */
    branch_id: number | null;
    config: FeatureSettingConfig | null;
    customer_tag?: (TransitionTagBrief & { status?: number; status_text?: string }) | null;
    origin_customer_tags?: TransitionTagBrief[];
    /** Chi tiết nhân sự theo config.staff_id / config.telesale_id */
    default_staff?: FeatureSettingStaff | null;
    default_telesale?: FeatureSettingStaff | null;
    is_active: 0 | 1;
    description?: string | null;
}

export interface FeatureSettingPayload {
    origin_customer_tag_ids?: number[];
    customer_tag_id?: number | null;
    sync_customer?: boolean;
    /** appointment_default_staff: server tự đóng gói vào config */
    staff_id?: number | null;
    telesale_id?: number | null;
    branch_id?: number | null;
    name?: string;
    is_active?: 0 | 1;
}

const BASE = `${API_URL}/api/v1/be/system-feature-settings`;

/**
 * GET /system-feature-settings/by-type/{type} — cấu hình đang áp dụng của một tính năng.
 * Có `branch_id` thì server ưu tiên cấu hình riêng của chi nhánh, không có thì lấy cấu hình chung.
 * `include_inactive=1`: thiếu thì dòng đang tắt bị báo "Chưa được cấu hình" và mất giá trị đã lưu.
 */
export async function getFeatureSettingByType(
    type: string,
    branchId?: number | null
): Promise<TransitionResponse<FeatureSetting>> {
    const qs = `?include_inactive=1${branchId ? `&branch_id=${branchId}` : ''}`;
    return request<FeatureSetting>(
        `${BASE}/by-type/${encodeURIComponent(type)}${qs}`,
        'GET',
        undefined,
        'Không tải được cấu hình tính năng'
    );
}

/** PUT /system-feature-settings/by-type/{type} — lưu cấu hình, server tự tạo mới nếu chưa có */
export async function updateFeatureSettingByType(
    type: string,
    payload: FeatureSettingPayload
): Promise<TransitionResponse<FeatureSetting>> {
    return request<FeatureSetting>(
        `${BASE}/by-type/${encodeURIComponent(type)}`,
        'PUT',
        payload,
        'Lưu cấu hình tính năng thất bại'
    );
}
